export default __webpack_public_path__ + "static/media/TRX.2ce9220a.svg";